import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-family-relationship.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetFamilyRelationshipDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metFamilyRelationshipEntity = useAppSelector(state => state.metFamilyRelationship.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metFamilyRelationshipDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.detail.title">MetFamilyRelationship</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metFamilyRelationshipEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.code">Code</Translate>
            </span>
          </dt>
          <dd>{metFamilyRelationshipEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.name">Name</Translate>
            </span>
          </dt>
          <dd>{metFamilyRelationshipEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{metFamilyRelationshipEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{metFamilyRelationshipEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metFamilyRelationship.status">Status</Translate>
            </span>
          </dt>
          <dd>{metFamilyRelationshipEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-family-relationship" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-family-relationship/${metFamilyRelationshipEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetFamilyRelationshipDetail;
